// app/config/menu.ts
import type { MenuItem } from '@xianlaibang/shared/types'
import iconProduct from '~/assets/scss/static/nav/nav-task@3x.png'
import iconProductActive from '~/assets/scss/static/nav/容器@3x (6).png'
import iconFunds from '~/assets/scss/static/nav/nav-recycle@3x.png'
import iconFundsActive from '~/assets/scss/static/nav/组 1681@3x.png'
import iconAccount from '~/assets/scss/static/nav/容器@2x.png'
import iconAccountActive from '~/assets/scss/static/nav/容器@2x (2).png'
import iconOpenPlatform from '~/assets/scss/static/nav/nav-platform@3x.png'
import iconOpenPlatformActive from '~/assets/scss/static/nav/容器@3x (7).png'

// 官网顶部导航（简版，对齐蓝湖原型）
export const mainMenu: MenuItem[] = [
  {
    index: '0',
    name: '首页',
    path: '/',
    icon: ElIconHomeFilled,
  },
  {
    index: '1',
    name: '商品管理',
    path: '/user/direct',
    icon: iconProduct,
    activeIcon: iconProductActive,
  },
  {
    index: '2',
    name: '资金管理',
    path: '/user/funds',
    icon: iconFunds,
    activeIcon: iconFundsActive,
  },
  {
    index: '3',
    name: '账号管理',
    path: '/user/account',
    icon: iconAccount,
    activeIcon: iconAccountActive,
  },
  {
    index: '4',
    name: '开放平台',
    path: '/user/api',
    icon: iconOpenPlatform,
    activeIcon: iconOpenPlatformActive,
  },
]



export const userMenu: MenuItem[] = [
    { index: '1', name: '工作台', path: '/user', icon: ElIconMonitor },
    { index: '2', name: '商品管理', path: '', icon: ElIconCollectionTag, children: [
      { index: '2-1', name: '话费直充', path: '/user/direct', icon: '' },
      { index: '2-2', name: '发布任务', path: '/user/task', icon: '' },
      { index: '2-3', name: '发布任务', path: '/user/task/release', icon: '', hide: true },
      { index: '2-4', name: '任务详情', path: '/user/task/release', icon: '', hide: true }
    ]},
    { index: '3', name: '订单管理', path: '', icon: ElIconTickets ,  children: [
      { index: '3-1', name: '订单中心', path: '/user/order', icon: '' },
      { index: '3-2', name: '任务中心', path: '/user/order/task', icon: '' },
      { index: '3-3', name: '售后订单', path: '/user/aftersales', icon: '' },
      // { index: '3-4', name: '导出记录', path: '/user/export', icon: '' }
    ]},
    { index: '4', name: '资金管理', path: '', icon: ElIconFolder, children: [
      { index: '4-1', name: '资金总览', path: '/user/funds', icon: '' },
      { index: '4-2', name: '充值账号', path: '/user/funds/account', icon: '' },
      { index: '4-3', name: '流水明细', path: '/user/funds/detail', icon: '' },
      { index: '4-4', name: '账户充值', path: '/user/funds/recharge', icon: '', hide: true},
    ]},
    { index: '5', name: '账户管理', path: '', icon: ElIconPostcard, children: [
      { index: '5-1', name: '账户信息', path: '/user/account', icon: '' },
      { index: '5-2', name: '资料管理', path: '/user/information', icon: '' },
    ]},
    { index: '6', name: '意见反馈', path: '/user/feedback', icon: ElIconNotebook },
    // { index: '7', name: '充值管理', path: '/user/recharge', icon: ElIconFiles },
    { index: '8', name: 'API对接', path: '/user/api', icon: ElIconFinished }
]
